declare const window: any;

const loggers = {};

export class Logger {
    private id: string;

    constructor(id: string) {
        const cached = loggers[id];
        if (cached) {
            return cached;
        }

        loggers[id] = this;
        this.id = id;
    }

    /**
     * Logs a debug message.
     *
     * @param args The data to log.
     */
    public debug(...args: any[]): void { /* stub */ }

    /**
     * Logs info.
     *
     * @param args The data to log.
     */
    public info(...args: any[]): void { /* stub */ }

    /**
     * Logs a warning.
     *
     * @param args The data to log.
     */
    public warn(...args: any[]): void { /* stub */ }

    /**
     * Logs an error.
     *
     * @param args The data to log.
     */
    public error(...args: any[]): void { /* stub */ }
}

export function connectConsole() {
    const proto = Logger.prototype;
    // NodeJS has no console.debug
    proto.debug = (console.debug || console.log).bind(console); // tslint:disable-line
    proto.info = console.info.bind(console); // tslint:disable-line
    proto.warn = console.warn.bind(console); // tslint:disable-line
    proto.error = console.error.bind(console); // tslint:disable-line
}

export function connectRaven(Raven) {
    const proto = Logger.prototype;

    const restToExtra = (rest: any[]) => {
        if (!rest.length) {
            return {};
        }

        const extra = {};
        if (typeof rest[0] === 'object') {
            Object.assign(extra, rest[0]);
        }
        return extra;
    };

    const safeId = (id) => id.replace(/\//g, '__');

    proto.debug = function(message, ...rest) { // tslint:disable-line
        Raven.captureMessage(message, { level: 'debug', logger: safeId(this.id), extra: restToExtra(rest) });
        (console.debug || console.log)(message, ...rest); // tslint:disable-line
    };
    proto.info = function(message, ...rest) { // tslint:disable-line
        Raven.captureMessage(message, { level: 'info', logger: safeId(this.id), extra: restToExtra(rest) });
        console.info(message, ...rest); // tslint:disable-line
    };
    proto.warn = function(message, ...rest) { // tslint:disable-line
        Raven.captureMessage(message, { level: 'warn', logger: safeId(this.id), extra: restToExtra(rest) });
        console.warn(message, ...rest); // tslint:disable-line
    };
    proto.error = function(messageOrError, ...rest) { // tslint:disable-line
        Raven.captureException(messageOrError, { level: 'error', logger: safeId(this.id), extra: restToExtra(rest) });
        console.error(messageOrError, ...rest); // tslint:disable-line
    };
}

if (process.env.NODE_ENV === 'development') {
    connectConsole();
} else if (process.env.NODE_ENV === 'test') {
    // Ignore all prints
} else {
    if (typeof window !== 'undefined' && window.Raven && window.Raven.isSetup()) {
        connectRaven(window.Raven);
    } else {
        // TODO: What here? NodeJS logging? Raven not setup?
        connectConsole();
    }
}

export function getLogger(id: string): Logger {
    return loggers[id] || new Logger(id);
}
